import React from 'react'
import { PageWrapper } from './PageWrapper'
import { Text, Select, Heading } from 'base-ui'
import { Select as SelectExample } from '../examples/Select'
import CodeSampleSelector from './CodeSampleSelector'


const Selects = () => {

  const [selectOptions] = React.useState([
    {
      label: 'Option 1',
      value: 'option-1',
    },
    {
      label: 'Option 2',
      value: 'option-2',
    },
  ])

  const handleSelect = (e: any) => {
    alert(`${e.target.value} event triggered`)
  }


  return (
    <PageWrapper title="Selects">
      <Text size="lg">The Select component allows users to pick a value from predefined set of options, ideally when selecting one between 5-10 options. Use a radio group when displaying less than 5 options or a searchable select for more than 10.</Text>
      <div className="py-2">
        <Select
          label="Select"
          options={selectOptions}
          required={false}
          onChange={e => handleSelect(e)}
        />
      </div>
      <div className="py-2">
        <Select
          label="Disabled Select"
          options={selectOptions}
          required={false}
          onChange={e => handleSelect(e)}
          disabled
        />
      </div>
      <div className="py-2">
        <Select
          label="Select with error"
          required={true}
          isInvalid={true}
          isInvalidText="Please enter a valid/required name"
          className="custom-class"
          onChange={e => handleSelect(e)}
          options={selectOptions}
        />
      </div>
      {/* Commenting this out in the docs since we are not currently using different sizes and the styling does not align with design system */}
      {/* <Heading size="h3">Size</Heading>
      <Text size="lg">By default the size is 'md'. Use the 'size' prop for bigger Select fields.</Text>
      <div className="py-2">
        <Select
          label="Select"
          options={selectOptions}
          required={false}
          onChange={e => handleSelect(e)}
          size="lg" // md, lg
        />
      </div> */}
      <Heading size="h3">Usage</Heading>
      
      <CodeSampleSelector
        baseUi={SelectExample}
        algoliaUi={`TBD`}
      />
    </PageWrapper>
  )
}

export default Selects
